import { Layout } from '@/utils/routerHelper'

// 直销区售后管理
export default {
  path: '/after-sale',
  redirect: '/after-sale/type',
  component: Layout,
  name: 'AfterSale',
  meta: {
    title: '直销区售后',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'chargeback',
      name: 'DirectSellingChargeback',
      component: () => import('@/views/AfterSale/DirectSelling/Chargeback/AfterSaleList/Index.vue'),
      meta: {
        title: '退单管理'
      },
      children: [
        {
          path: 'check-order',
          name: 'DirectSellingChargebackCheckOrder',
          component: () =>
            import('@/views/AfterSale/DirectSelling/Chargeback/AfterSaleList/CheckOrder/Index.vue'),
          meta: {
            title: '选择订单',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/chargeback'
          }
        },
        {
          path: 'confirm-info',
          name: 'DirectSellingChargebackConfirmInfo',
          component: () =>
            import(
              '@/views/AfterSale/DirectSelling/Chargeback/AfterSaleList/ConfirmInfo/Index.vue'
            ),
          meta: {
            title: '发起退单',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/chargeback'
          }
        },
        {
          path: 'detail',
          name: 'DirectSellingChargebackDetail',
          component: () =>
            import('@/views/AfterSale/DirectSelling/Chargeback/AfterSaleDetail/Index.vue'),
          meta: {
            title: '退单详情',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/chargeback'
          }
        },
        {
          path: 'service-confirm',
          name: 'DirectSellingChargebackServiceConfirm',
          component: () =>
            import('@/views/AfterSale/DirectSelling/Chargeback/ServiceConfirm/Index.vue'),
          meta: {
            title: '客服确认',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/chargeback'
          }
        }
      ]
    },
    {
      path: 'remove-order',
      name: 'DirectSellingRemoveOrder',
      component: () =>
        import('@/views/AfterSale/DirectSelling/RemoveOrder/AfterSaleList/Index.vue'),
      meta: {
        title: '删单管理'
      },
      children: [
        {
          path: 'check-order',
          name: 'DirectSellingAfterSaleCheckOrder',
          component: () =>
            import(
              '@/views/AfterSale/DirectSelling/RemoveOrder/AfterSaleList/CheckOrder/Index.vue'
            ),
          meta: {
            title: '选择订单',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/remove-order'
          }
        },
        {
          path: 'confirm-info',
          name: 'DirectSellingAfterSaleConfirmInfo',
          component: () =>
            import(
              '@/views/AfterSale/DirectSelling/RemoveOrder/AfterSaleList/ConfirmInfo/Index.vue'
            ),
          meta: {
            title: '发起删单',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/remove-order'
          }
        },
        {
          path: 'detail',
          name: 'DirectSellingAfterSaleDetail',
          component: () =>
            import('@/views/AfterSale/DirectSelling/RemoveOrder/AfterSaleDetail/Index.vue'),
          meta: {
            title: '售后详情',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/remove-order'
          }
        }
      ]
    },
    {
      path: 'change-goods',
      name: 'DirectSellingChangeGoods',
      component: () =>
        import('@/views/AfterSale/DirectSelling/ChangeGoods/AfterSaleList/Index.vue'),
      meta: {
        title: '换货管理'
      },
      children: [
        {
          path: 'check-order',
          name: 'DirectSellingChangeGoodsCheckOrder',
          component: () =>
            import(
              '@/views/AfterSale/DirectSelling/ChangeGoods/AfterSaleList/CheckOrder/Index.vue'
            ),
          meta: {
            title: '选择订单',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/change-goods'
          }
        },
        {
          path: 'confirm-info',
          name: 'DirectSellingChangeGoodsConfirmInfo',
          component: () =>
            import(
              '@/views/AfterSale/DirectSelling/ChangeGoods/AfterSaleList/ConfirmInfo/Index.vue'
            ),
          meta: {
            title: '发起换货',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/change-goods'
          }
        },
        {
          path: 'detail',
          name: 'DirectSellingChangeGoodsDetail',
          component: () =>
            import('@/views/AfterSale/DirectSelling/ChangeGoods/AfterSaleDetail/Index.vue'),
          meta: {
            title: '换货详情',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/change-goods'
          }
        },
        {
          path: 'service-confirm',
          name: 'DirectSellingChangeGoodsServiceConfirm',
          component: () =>
            import('@/views/AfterSale/DirectSelling/ChangeGoods/ServiceConfirm/Index.vue'),
          meta: {
            title: '客服确认',
            canTo: true,
            hidden: true,
            activeMenu: '/after-sale/change-goods'
          }
        }
      ]
    },
    {
      path: 'again-report',
      name: 'DirectSellingAgainReport',
      component: () => import('@/views/AfterSale/DirectSelling/AgainReport/Index.vue'),
      meta: {
        title: '重新报单'
      }
    },
    {
      path: 'offline-after-sale-order',
      name: 'DirectSellingOfflineAfterSalesOrder',
      component: () => import('@/views/AfterSale/DirectSelling/OfflineAfterSalesOrder/Index.vue'),
      meta: {
        title: '线下售后单',
        hidden: true
      }
    }
  ]
} as AppRouteRecordRaw
